'use strict';

/**
 * @doc module
 * @name SpeedScreen
 * @description
 *
 * speedyScreen.
 */

var app = angular.module('harriApp');

import {searchMobileDeActivateSS, showOnSSDeActivate} from './speedy-screen.utils.js';


app.directive('speedyScreenModal', [function () {
    return {
        templateUrl: "../modules/speedy_screen/views/speedyscreen_modal.html",
        restrict: 'E',
        transclude: true,
        replace: true,
        scope: {
            moveRightFn: '&',
            moveLeftFn: '&',
            show: '='
        },
        link: function ($scope, $element, $attr, controller, transclude) {

            if ($attr.show && $attr.show != "false") {
                $('#speedy-screen-modal').modal('show');
            }
        }
    };
}]);

app.directive('closeModalSs', ["$state", function ($state) {
    return {
        link: function ($scope, $element, $attr) {
            $('#closeSpeedyScreen').unbind('#closeSpeedyScreen');
            $('#closeSpeedyScreen').click(function () {
                var isTinyScreen = deviceChecker.isTinyScreen();
                if (/ams/.test(window.location.href)) {
                    if (isTinyScreen) {
                        showOnSSDeActivate();
                    }
                    $state.go('^');
                }
                else {
                    if (isTinyScreen) {
                        searchMobileDeActivateSS();
                    }
                    $('#speedy-screen-modal').modal('hide');
                }
            });
        }
    }
}]);

app.directive('ssFullScreen', ["$state", "deviceChecker", function ($state, deviceChecker) {
    return {
        link: function ($scope, $element, $attr) {
            if (deviceChecker.isTinyScreen()) {
                $element.addClass('modal-xs-fullscreen');
            }
        }
    }
}]);


app.directive('swipeTrigger', [function () {
    return {
        link: function ($scope, $element, $attr) {


            $element.swipe({
                //Generic swipe handler for all directions
                swipeRight: function (event, direction, distance, duration, fingerCount, fingerData) {
                    event.preventDefault();
                    $scope.moveLeftFn();
                },
                swipeLeft: function (event, direction, distance, duration, fingerCount, fingerData) {
                    event.preventDefault();
                    $scope.moveRightFn();
                },

                /* swipeStatus:function(event, phase, direction, distance){


                 @shox cool effect to be implemented in a parallel universe :P

                 var dPixel = distance + 'px';
                 $('.active-ss').css({
                 'left': ( direction == 'left' )? '-'+dPixel:dPixel
                 });

                 if( direction == 'left' && $('.active-ss').next() ){
                 $('.active-ss').next().show();
                 $('.active-ss').next().css({
                 'left': dPixel
                 });
                 }
                 else if($('.active-ss').prev()){
                 $('.active-ss').prev().show();
                 $('.active-ss').prev().css({
                 'left': '-'+dPixel
                 });
                 }

                 },*/
                triggerOnTouchEnd: false,
                //Default is 75px, set to 0 for demo so any distance triggers swipe
                threshold: 75
            });

        }
    }
}]);


app.directive('triggerKey', function () {
    return {
        link: function ($scope, $element, $attr) {
            $element.click(function () {
                var e = jQuery.Event("keydown");
                // only works with Int
                e.which = parseInt($attr.triggerKey);
                $(document).trigger(e);
            });
        }
    }
})
app.directive('hLoading', [function () {
    return {
        restrict: 'E',
        replace: true,
        template: '  <div class="h-loading"> \
                    <i class="fa fa-circle-o-notch fa-spin"></i> {{"Loading"|translate}} \
                </div>',
        link: function ($scope, $element, $attr, controller, transclude) {

        }
    }
}]);

app.directive('fixedOnScroll', [function () {
    return {
        link: function ($scope, $element, $attr, controller, transclude) {
            var $modal = $('.modal');

            $modal.unbind('scroll');
            $modal.scroll(function () {
                $element.find($attr.fixedOnScroll).css('top', ( $('.modal').scrollTop() + 300) + 'px')
            });
        }
    }
}]);

app.directive('forceResize', ['$timeout', function ($timeout) {
    return {
        link: function ($scope, $element, $attr) {
            // fixes issue in BS modal
            $timeout(function () {
                $(window).trigger('resize');
            });
        }
    }
}]);

/*
 * open or colose toolbox in SpeedX
 * **/
app.directive('openToolboxSpeedyX', ["$state", "$filter", function ($state, $filter) {
    return {
        link: function ($scope, $element, $attr) {
            $element.off('click')
                .on('click', function () {
                    if ($element.hasClass('toggled')) {
                        $('.candidate-card-modal .toolbox').removeClass('toggled');
                        $element.removeClass('toggled');
                        $element.text($filter("translate")("Open Toolbox"));
                    } else {
                        $('.candidate-card-modal .toolbox').addClass('toggled');
                        $element.addClass('toggled');
                        $element.text($filter("translate")("Close Toolbox"));
                    }
                });
        }
    }
}]);



